import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';

export function getProgramSlug(challenge: Challenge) {
  return challenge?.settings?.seo?.slug || challenge?.id || '';
}
